import _Hero from './hero/SearchHero.vue';
import _HeroSection from './hero-section/HeroSection.vue';
import _DividerSection from './divider/DividerSection.vue';
import _LoadingSpinner from './LoadingSpinner.vue';
import _PaginationControls from './PaginationControls.vue';
import _LegendFooter from './LegendFooter.vue';

export const Hero = _Hero;
export const HeroSection = _HeroSection;
export const DividerSection = _DividerSection;
export const LoadingSpinner = _LoadingSpinner;
export const PaginationControls = _PaginationControls;
export const LegendFooter = _LegendFooter;
